import React from 'react';

const ScanCrossChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M13.364 11.95l3.535 3.535-1.414 1.414-3.535-3.535-3.536 3.535L7 15.485l3.536-3.535L7 8.414 8.414 7l3.536 3.536L15.485 7 16.9 8.414l-3.535 3.536zM22 9.035V2h-6.985v2.022h5.033v5.013H22zM14.975 22.01v-1.952h5.013v-5.033h2.022v6.985h-7.035zM9.023 2v1.952h-5v5.063H2V2h7.023zm-7.02 12.996h1.953v5h5.063v2.023H2.004v-7.023z"
            fillRule="evenodd"
        />
    </svg>
);

ScanCrossChunkySvg.displayName = 'ScanCrossChunkySvg';
export default ScanCrossChunkySvg;
